<!-- ChatBox.vue -->
<template>
   <div class="chat-box">
      <!--<h2>Ask FusionCharts AI</h2>
    <p>Here would come what is the use of using fusionchart AI and the benifits of using it.</p>
   --><!-- <div class="chat-messages">
      <div v-for="(message, index) in messages" :key="index" class="message" :class="{ 'user-message': message.sender === 'user' }">
        {{ message.text }}
      </div>
    </div>-->
      <div class="custom-container-1440 textarea-container">
         <div class="chat-question-container">
            <!-- <textarea
     ref="input"
    v-model="userInput"
    class="chat-question custom-scrollbar"
     placeholder="Enter your Question"
    @input="adjustTextarea"
    placeholder="Enter your question (Hit Shift + Enter to add a second line of text)"
    @keydown.enter.prevent="sendMessage"

    >
    </textarea>-->
            <textarea
               ref="input"
               v-model="userInput"
               class="chat-question custom-scrollbar"
               :placeholder="placeholderText"
               @input="adjustTextarea"
               @keypress="handleKeyPress"
            >
            </textarea>
            <div class="circle"></div>
            <!-- Circular element -->
            <button
               class="send_icon"
               :class="{ send_icon: true, enabled: typingStarted, disabled: !typingStarted }"
               :disabled="!typingStarted"
               @click="sendMessage"
            ></button>
         </div>
      </div>
      <div class="button-container">
         <!--<button @click="showFeedbackModal">Feedback</button>-->
      </div>
      <div class="feedback_conatiner text-center">
         Provide your
         <a style="color:#6957da; cursor:pointer;" @click="showFeedbackModal">Feedback</a>
      </div>
      <!-- Feedback modal -->
      <div class="feedback_conatiner text-center">
         <a style="color:#6957da; cursor:pointer;" href="/contact-support">Contact Support</a>
      </div>
      <FeedbackModal
         :show-modal="feedbackModalVisible"
         @close="feedbackModalVisible = false"
         @submit="handleFeedbackSubmit"
      ></FeedbackModal>
   </div>
</template>

<script>
import FeedbackModal from './FeedbackModal.vue';

export default {
   name: 'ChatBox',
   components: {
      FeedbackModal,
   },
   data() {
      return {
         userInput: '',
         isMobile: false,
         messages: [],
         feedbackModalVisible: false,
         typingStarted: false,
      };
   },
   computed: {
      placeholderText() {
         return this.isMobile
            ? 'Enter your question'
            : 'Enter your question (Hit Shift + Enter to add a second line of text)';
      },
   },
   mounted() {
      // Check if the screen width is less than a certain threshold (e.g., for mobile)
      this.isMobile = window.innerWidth < 768; // Adjust the threshold as needed
      // Listen for resize events to update the isMobile value
      window.addEventListener('resize', () => {
         this.isMobile = window.innerWidth < 768; // Adjust the threshold as needed
      });
   },
   methods: {
      handleKeyPress(event) {
         if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();

            this.sendMessage();
         }
      },
      checkButton() {
         if (this.userInput) {
            this.typingStarted = true;
         } else {
            this.typingStarted = false;
         }
      },
      adjustTextarea() {
         this.checkButton();
         this.resetInputHeight();
      },
      resetInputHeight() {
         const { input } = this.$refs;
         input.style.height = 'auto'; // Reset height to auto
         // Set height to scrollHeight
         input.style.overflowY = 'auto';
         if (this.userInput) {
            input.style.height = `${input.scrollHeight - 38}px`;
         } else {
            input.style.height = '45px';
            input.style.overflowY = 'hidden';
            input.style.lineHeight = '48px';
         }
      },
      sendMessage() {
         if (this.userInput.trim() !== '') {
            this.messages.push({ text: this.userInput, sender: 'user' });
            this.$emit('user-question', this.userInput); // Emit the question to the parent component
            this.userInput = '';
            this.typingStarted = false;
            this.resetInputHeight();
         }
      },
      sendFeedback() {
         // Handle feedback functionality
         // For example: Open a modal or perform an action
         this.feedbackModalVisible = true;
      },
      showFeedbackModal() {
         this.feedbackModalVisible = true;
      },
      handleFeedbackSubmit(feedbackData) {
         // Handle feedback submission here
         // console.log('Received feedback:', feedbackData);
         // For now, let's just add a thank you message to the chat
         const thankYouMessage = 'You: Thank you for your feedback!';
         this.messages.push({ text: thankYouMessage, sentByMe: false });
      },
   },
};
</script>

<style scoped>
.container-content {
   padding-top: 98px;
}
.chat-question {
   width: 100%;
   background: black;
   color: white;
   resize: none;
   overflow-y: hidden;
   display: flex;
   align-items: center;
   font-size: 18px;
   max-height: 200px;
   height: 45px;
   line-height: 43px !important;
   border: none;
   padding-left: 20px;
   padding-right: 35px;
   margin-bottom: 0px;
}
.chat-question-container {
   background: black;
   padding: 14px 20px;
   border-radius: 30px;
   min-height: 40px;
   margin: 0px 0px 0px 28px;
   display: flex;
   align-items: center;
   justify-content: center;
}
.chat-box {
   /* width: 300px;*/
   padding: 20px;
   border: 1px solid #ccc;
   border-radius: 5px;
   background-color: #f0f0f0;
}

.chat-messages {
   max-height: 200px;
   overflow-y: auto;
}

.message {
   margin-bottom: 10px;
   padding: 5px 10px;
   border-radius: 5px;
}

.user-message {
   background-color: #f0f0f0;
}

textarea {
   width: calc(100% - 40px);
   margin-bottom: 10px;
}

.button-container {
   display: flex;
   justify-content: space-between;
}

.button-container button {
   background-color: #4caf50;
   color: white;
   border: none;
   border-radius: 5px;
   padding: 10px 20px;
   cursor: pointer;
}

.button-container button:hover {
   background-color: #45a049;
}
</style>

<style scoped>
.textarea-container {
   position: relative;
   /* display: inline-block;*/
   width: 100%;
}

.textarea-container .send_icon {
   position: absolute;
   top: 35px;
   right: 73px; /* Adjust according to the desired position */
   @media (max-width: 768px) {
      top: 40px;
      right: 62px;
   }
   transform: translateY(-50%);
   cursor: pointer;

   height: 24px;
   width: 24px;
   background-repeat: no-repeat;
   background-color: black;
   border: navajowhite;
}
.send_icon.enabled {
   background-image: url('/public/images/chat-feedback/fc-icon-send-100.svg');
}
.send_icon.disabled {
   background-image: url('/public/images/chat-feedback/fc-icon-send-80.svg');
}
</style>

<style>
/* width */
.custom-scrollbar {
   overflow-y: auto;
}
.custom-scrollbar::-webkit-scrollbar,
.response-container::-webkit-scrollbar {
   width: 8px;
}

/* Track */
.custom-scrollbar::-webkit-scrollbar-track,
.response-container::-webkit-scrollbar-track {
   box-shadow: inset 0 0 5px grey;
   border-radius: 10px;
}

/* Handle */
.custom-scrollbar::-webkit-scrollbar-thumb,
.response-container::-webkit-scrollbar-thumb {
   background: #555;
   border-radius: 10px;
}

/* Handle on hover */
.custom-scrollbar::-webkit-scrollbar-thumb:hover,
.response-container::-webkit-scrollbar-thumb:hover {
   background: #555;
}
.textarea-container .circle {
   position: absolute;
   bottom: 0;
   right: 0;
   width: 10px;
   height: 10px;
   background-color: RGB(236 194 62) 5;
   border-radius: 50%; /* Make it circular */
}
</style>
